<div class="block__left-side-panel">
    <div *ngIf="!(editMode$ | async)">
        <h1 class="text-items__title">{{'ADD_TRAVEL_CARD_SIDE_TITLE' | translate}}</h1>
        <p class="text-items__description"><span>{{'ADD_TRAVEL_CARD_SIDE_DESCRIPTION' | translate}}</span></p>
    </div>

    <div class="text-items" *ngIf="(editMode$ | async)">
        <h1 class="text-items__title">{{'EDIT_TRAVEL_CARD_SIDE_TITLE' | translate}}</h1>
        <p class="text-items__description"><span>{{'EDIT_TRAVEL_CARD_SIDE_DESCRIPTION' | translate}}</span></p>
    </div>
</div>
